import React, { forwardRef } from 'react';
import type { StackProps } from '@mui/material';
import { Stack as StackMUI } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_FLEX_WRAP, CUSTOM_ATTRIBUTE_FULL_WIDTH } from './Stack.api';

export type Props = {
  spacing?: StackProps['spacing'] | number[];
  fullWidth?: boolean;
  flexWrap?: 'wrap' | 'wrap-reverse' | 'nowrap';
};

const Stack = forwardRef<HTMLDivElement, StackProps & Props>((props, ref) => {
  const theme = useTheme();

  return (
    <StackMUI
      {...omitUndefinedProps({
        ...props,
        fullWidth: undefined,
        flexWrap: undefined,
        [CUSTOM_ATTRIBUTE_FLEX_WRAP]: props.flexWrap,
        [CUSTOM_ATTRIBUTE_FULL_WIDTH]: props.fullWidth ? '' : undefined,
      })}
      spacing={
        Array.isArray(props.spacing)
          ? props.spacing.map((num) => theme.spacing(num as number)).join(' ')
          : props.spacing
      }
      ref={ref}
    />
  );
});

Stack.displayName = 'Stack';

export default Stack;
